import { isWithinDateWindow, type DateWindow } from "../utils/TimeUtils";
import type { Holiday } from "../scene/environment/EnvironmentDecorator";

interface HolidayDefinition {
  id: Exclude<Holiday, null>;
  vignetteId: string;
  window: DateWindow;
}

// Christmas (Phase 3), Halloween + July 4th (Phase 5) implemented so far —
// St Patrick's and New Year's Eve remain open follow-ups.
const HOLIDAYS: HolidayDefinition[] = [
  { id: "christmas", vignetteId: "christmas", window: { startMonth: 12, startDay: 18, endMonth: 12, endDay: 26 } },
  { id: "halloween", vignetteId: "halloween", window: { startMonth: 10, startDay: 24, endMonth: 11, endDay: 1 } },
  { id: "july4th", vignetteId: "july4th", window: { startMonth: 6, startDay: 30, endMonth: 7, endDay: 5 } },
];

/** Maps real-calendar windows to holiday ids and their vignette. Real Date, never simulated island time — an optional `now` override exists purely for testing outside the real window. */
export class HolidayCalendar {
  getActiveHoliday(now: Date = new Date()): Holiday {
    return this.findActive(now)?.id ?? null;
  }

  /** The vignette id that should be near-guaranteed while its holiday window is active, or null. */
  getActiveHolidayVignetteId(now: Date = new Date()): string | null {
    return this.findActive(now)?.vignetteId ?? null;
  }

  private findActive(now: Date): HolidayDefinition | undefined {
    return HOLIDAYS.find((h) => isWithinDateWindow(now, h.window));
  }
}
